import { Api } from '../../client';

import type { VirtualCareUserEvent } from '../../../../types';

export const ingestUserEvents = async (events: VirtualCareUserEvent[]) => {
  const res = await Api.post('/v1/analytics/ingest', { events });
  return res.data;
};
